/**
 * pinchZoom — matemática del pellizco, sin DOM.
 *
 * POR QUÉ EXISTE
 * ---------------------------------------------------------------------------
 * El gesto de dos dedos es la parte del mapa que no se puede probar con un
 * test de componente (jsdom no tiene punteros). Sacando la cuenta aquí, un test
 * normal comprueba lo único que puede salir mal: que el punto que hay bajo los
 * dedos se quede quieto y que el zoom respete sus límites.
 *
 * `mx`/`my` son coordenadas RELATIVAS al recuadro del lienzo (clientX − rect.left)
 * y `pan` es la traslación del plano en píxeles. El zoom `z` escala desde la
 * esquina superior izquierda del plano, así que el punto de contenido bajo el
 * centro de los dedos es `(m − pan) / z`.
 */

/** @returns {{ zoom: number, pan: { x: number, y: number } }} */
export function pinchTransform({
  z0,
  pan0,
  mx0,
  my0,
  mx,
  my,
  d0,
  d,
  min = 0.2,
  max = 8,
}) {
  const base = Number(z0) > 0 ? Number(z0) : 1;
  const ratioDist = Number(d0) > 0 ? Number(d) / Number(d0) : 1;
  const zoom = Math.min(max, Math.max(min, base * ratioDist));
  const ratio = zoom / base;
  return {
    zoom,
    pan: {
      x: mx - (mx0 - pan0.x) * ratio,
      y: my - (my0 - pan0.y) * ratio,
    },
  };
}

export default pinchTransform;
